import {useEffect} from "react"
import {useDispatch, useSelector} from "react-redux"
import {useLocation} from "react-router-dom"
import {authSlice, authSelectors} from "scholastic-client-components/src/slices/authSlice"
import {AuthResponse} from "scholastic-client-components/src/api/authAPI"
import {Portal, PortalRoute} from "scholastic-client-components/src/types/securityTypes"
import {setAxiosTokenHeader} from "scholastic-client-components/src/lib/axios"
import {ReferrerSearchParams} from "scholastic-client-components/src/lib/routing"
import {UrlParams} from "../lib/routing"
import {authAPI} from "./../api/connectedAPI"
import {useCanvaHeaders} from "./useCanvaHeaders"
import {useAuthStorage} from "scholastic-client-components/src/hooks/useAuthStorage"

interface Args {
    turnOff?: boolean
}

export const useAuth = ({turnOff}: Args = {}) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const canvaHeaders = useCanvaHeaders()
    const {setValue} = useAuthStorage(useSelector)

    useEffect(() => {
        if (turnOff) {
            return
        }

        dispatch(authSlice.actions.startAuth())
        dispatch(
            (authAPI.auth as any)({
                config: {
                    headers: canvaHeaders,
                },
                includeHeaders: ["etag"],
                onSuccess: (response: AuthResponse, _: any, {etag}: any) => {
                    const urlParams = new URLSearchParams(location.search)
                    if (urlParams.get(UrlParams.DeviceId)) {
                        setAxiosTokenHeader(response.token, etag)
                        dispatch(
                            authSlice.actions.successAuth({...response, etag, portal: Portal.Auth})
                        )
                        setValue()
                    } else {
                        if (canvaHeaders["canva-id"]) {
                            window.location.replace(
                                "/api/canva/redirect?state=" + canvaHeaders["canva-state"]
                            )
                        } else {
                            dispatch(
                                authSlice.actions.successAuth({
                                    ...response,
                                    etag,
                                    portal: Portal.Auth,
                                })
                            )
                            setValue()

                            const referrerUrl = decodeURIComponent(
                                urlParams.get(ReferrerSearchParams.URL) || ""
                            )
                            setTimeout(() => {
                                window.location.replace(referrerUrl || PortalRoute[Portal.Home])
                            }, 0)
                        }
                    }
                },
                onError: () => {
                    dispatch(authSlice.actions.failAuth())
                },
            })
        )
    }, [dispatch])

    return useSelector(authSelectors.getAuthValues)
}
